import { useParams } from 'react-router-dom';
import LogGroupCard from '../components/LogGroupCard';
import { INSTAPAY_APP_LOG_SOURCES } from '../data/instapayAppLogSources';

// One dynamic route (/instapay-app-logs/:slug) backs all 5 "InstapayApp
// Logs" dropdown items, rather than 5 near-identical page files/routes -
// the only thing that differs between them is which slug/log group to show,
// which INSTAPAY_APP_LOG_SOURCES already carries.
export default function InstapayAppLogs() {
  const { slug } = useParams();
  const meta = INSTAPAY_APP_LOG_SOURCES.find((s) => s.slug === slug);

  if (!meta) {
    return (
      <div>
        <h1 className="h4 mb-2">Instapay App Logs</h1>
        <div className="alert alert-warning py-2">Unknown log source &ldquo;{slug}&rdquo;.</div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="h4 mb-1">{meta.label}</h1>
      <p className="text-muted small mb-3">
        Logs from <code>{meta.logGroupHint}</code>.
      </p>
      <LogGroupCard source={meta.slug} />
    </div>
  );
}
